import { useRef } from 'react';
import { isEqual } from 'lodash-es';

function useDeepMemo(factory, deps) {
    const ref = useRef();
    if (ref.current === undefined || isEqual(deps, ref.current.deps) === false) {
        ref.current = {
            value: factory(),
            deps
        };
    }
    return ref.current.value;
}

export { useDeepMemo };
//# sourceMappingURL=deep-memo.js.map
